import { levels } from '../data/resources';

export default {
    computed: {
        profileLevel() {
            return levels.find(key => key.id == this.profileData.WorkRate)?.level;
        },
        profileTitle() {
            const speciality = this.profileData.Speciality;
            if (!speciality) return '';
            return speciality?.split(' ').length > 1 && !speciality.includes('tack')
                ? speciality
                : speciality.includes('cience')
                ? 'Data Scientist'
                : `${speciality} Engineer`;
        },
        profileFraction() {
            let count = 0;
            for (let i in this.profileData) {
                if (this.profileData[i]) count++;
            }
            return count;
        },
        completedJobs() {
            return this.profileData.MyProjects || [];
        },
        portfolioLink() {
            return this.profileData.GithubLink || (this.profileData.PortfolioLinks || []).toString();
        },
        profileImage() {
            return this.data.AvatarHref || this.userImg;
        },
    },
    methods: {
        async getProfile() {
            const id = localStorage.getItem('id');
            const token = localStorage.getItem('token');

            try {
                const res = await this.$api({
                    url: `/talents/profiles/${id}`,
                    method: 'get',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                let profileData = res.data;

                const { path } = this.$route;
                if (!path.includes('browse') && !res.data.CoreTechstack) {
                    this.checkSignupData();
                }

                this.profileData = profileData;
                this.profileScore = [
                    {
                        title: 'Projects completed with top tech stack',
                        score: (profileData.ProjectsCompletedLinks || []).length,
                    },
                    {
                        title: 'Years of experience with top tech stack',
                        score: profileData.WorkExperience,
                    },
                    {
                        title: 'Number of Project Completed being a Team Lead',
                        score: profileData.ProjectsLedCount,
                    },
                    {
                        title: 'Number of Remote Work Completed',
                        score: (profileData.RemoteProjectLinks || []).length,
                    },
                ];

                this.$store.commit('profiles/addProfile', profileData);
                if (!this.$route.path.includes('browse')) this.storeTalentData(this.profileData);
            } catch (err) {
                console.log({ err });

                if (!err.response) throw new Error('Network Error!');
                this.catchErrors(err);
            }
        },
        checkSignupData() {
            const { path } = this.$route;
            const talentData = JSON.parse(localStorage.getItem('talentData'));

            if (!talentData) return this.$router.push(`/devsignup`);

            this.$store.commit('talent/addToTalent', talentData);
            const { core_techstack, core_techstack_experience, work_experience, country } = talentData;

            const link = !core_techstack
                ? ''
                : core_techstack_experience == null
                ? '/speciality'
                : work_experience == null
                ? '/experience'
                : !country
                ? '/devs'
                : '/overview';

            if (!path.includes(link)) return this.$router.push(`/devsignup${link}`);
        },
        storeTalentData(data) {
            const {
                Specializations: specializations,
                CoreTechstack: core_techstack,
                ProjectsCompletedLinks: projects_completed_links,
                Speciality: speciality,
                EnglishProficiency: english_proficiency,

                CoreTechstackExperience: core_techstack_experience,
                OtherCoreTechstacks: other_core_techstacks,
                OtherCoreTechstackProjects: other_core_techstack_projects,
                OtherCoreTechstackProjectCount: other_core_techstack_project_count,
                WorkRate: work_rate,
                GithubLink: github_link,
                PortfolioLinks: portfolio_links,

                WorkExperience: work_experience,
                RemoteProjectLinks: remote_projects_links,
                Companies: company,
                Educations: education,
                Country: country,
                ProjectLeader: project_leader,
                AboutMe: about_me,
                City: city,
                ProjectsLedCount: projects_led_count,
                ProjectsLed: projects_led,
            } = data;

            this.$store.commit('talent/addToTalent', {
                core_techstack,
                projects_completed_links,
                speciality,
                english_proficiency,

                core_techstack_experience,
                other_core_techstacks,
                other_core_techstack_projects,
                other_core_techstack_project_count,
                work_rate,
                github_link,
                portfolio_links,
                specializations,

                work_experience,
                remote_projects_links,
                company: (company || []).filter(value => value.Role && value.Organization),
                education: (education || []).filter(value => value.Institution && value.Course),
                country,
                project_leader,
                about_me,
                city,
                projects_led_count,
                projects_led,
            });

            this.loading = false;
        },
    },
};
